import React from "react";
import { FormControl, IconButton } from "@mui/material";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/AddCircleOutline";
import { TicketLineItemExtended } from "../../../Utils/TypeExtensions";
import { DUMMY_FUEL_LINE_ITEM_TYPE } from "../../../sharedCode/metadata";
import DetailPage from "../../../Components/navigation/detailPage";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import FuelFooter from "../../../Components/ticket/fuelFooter";
import FuelDetails from "../../../Components/ticket/fuelDetails";
import { addLineItem } from "../../../Utils/TicketDatabase";

export function TicketFuel(props: TicketProps): JSX.Element {
    return (
        <DetailPage>
            <FormControl fullWidth>
                <FuelDetails {...props} />
                <FuelFooter {...props} />
                <Typography>
                    <IconButton disabled={props.isReadOnly} size="large" color="inherit" sx={{ ml: 2, mr: 2, alignItems: "left" }} onClick={handleAdd}>
                        <AddIcon />
                    </IconButton>
                </Typography>
            </FormControl>
        </DetailPage>
    );

    function handleAdd(): void {
        const id = props.ticket.nextLocalId;
        const newLineItem = {
            id,
            comments: "",
            ticket_id: props.ticket.id,
            line_item_type_id: DUMMY_FUEL_LINE_ITEM_TYPE,
        } as TicketLineItemExtended;

        addLineItem(props.ticket.id, newLineItem).catch(() => props.showForceReloadDialogue());
    }
}
